import { extendTheme } from "@chakra-ui/react";

// Фирменные цвета А.Т.И.К.А. арт клуба
export const BRAND = {
  paper: "#F2DFB6", // бежевая «бумага»
  card: "#FBF0D9", // светлая карточка
  cream: "#FDF7E9", // почти белый крем
  deep: "#ECCFA7", // тёмный беж (как на логотипе)
  line: "#E4D2A6", // тонкие линии
  border: "#D3BC8D", // рамки
  ink: "#243D27", // тёмно-зелёные «чернила»
  inkSoft: "rgba(36, 61, 39, 0.62)",
  wine: "#8D414B", // бордо
  wineDark: "#7A3841",
};

const theme = extendTheme({
  fonts: {
    heading: "'Prata', 'Golos Text', serif",
    body: "'Golos Text', -apple-system, sans-serif",
  },
  shadows: {
    outline: "0 0 0 3px rgba(141, 65, 75, 0.35)",
  },
  colors: {
    beige: {
      50: "#FDF7E9",
      100: "#FBF0D9",
      200: "#F2DFB6",
      300: "#ECCFA7",
      400: "#D3BC8D",
      500: "#B89F6E",
    },
    pine: {
      50: "#EBF1EB",
      100: "#CEDDCF",
      200: "#A3BFA6",
      300: "#78A07D",
      400: "#4C6B51",
      500: "#2E4A33",
      600: "#243D27",
      700: "#1C301F",
      800: "#142317",
      900: "#0D170F",
    },
    burgundy: {
      50: "#F8ECEE",
      100: "#ECD2D6",
      200: "#DBAEB5",
      300: "#C98893",
      400: "#A85763",
      500: "#8D414B",
      600: "#7A3841",
      700: "#632D35",
      800: "#4B2228",
      900: "#341318",
    },
  },
  styles: {
    global: {
      body: {
        bg: "#F2DFB6",
        color: "#243D27",
      },
      "*::placeholder": {
        color: "rgba(36, 61, 39, 0.42)",
      },
      "::selection": {
        background: "rgba(141, 65, 75, 0.25)",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "12px",
        fontWeight: 500,
        letterSpacing: "0.02em",
        transition: "all 0.18s ease",
      },
    },
    Input: {
      variants: {
        filled: {
          field: {
            bg: "#FDF7E9",
            borderRadius: "12px",
            border: "1px solid",
            borderColor: "#D3BC8D",
            transition: "all 0.18s ease",
            _hover: { bg: "#FFFBF0", borderColor: "#B89F6E" },
            _focus: {
              bg: "#FFFBF0",
              borderColor: "#8D414B",
              boxShadow: "0 0 0 3px rgba(141, 65, 75, 0.18)",
            },
          },
        },
      },
      defaultProps: {
        variant: "filled",
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: "#FBF0D9",
          borderRadius: "18px",
          border: "1px solid #D3BC8D",
          boxShadow: "0 30px 80px -20px rgba(20, 35, 23, 0.45)",
        },
      },
    },
    Drawer: {
      baseStyle: {
        dialog: {
          bg: "#FBF0D9",
        },
      },
    },
    Menu: {
      baseStyle: {
        list: {
          bg: "#FBF0D9",
          borderColor: "#D3BC8D",
          borderRadius: "14px",
          boxShadow: "0 18px 50px -12px rgba(20, 35, 23, 0.35)",
          color: "#243D27",
          py: 2,
        },
        item: {
          borderRadius: "8px",
          mx: 2,
          width: "auto",
          transition: "background 0.15s ease",
          _hover: { bg: "rgba(141, 65, 75, 0.10)" },
          _focus: { bg: "rgba(141, 65, 75, 0.10)" },
        },
      },
    },
    Tooltip: {
      baseStyle: {
        bg: "#243D27",
        color: "#F2DFB6",
        borderRadius: "8px",
        px: 3,
        py: 1.5,
      },
    },
    Avatar: {
      baseStyle: {
        container: {
          bg: "#8D414B",
          color: "#FBF0D9",
        },
      },
    },
  },
});

export default theme;
